import React from "react";
import {Box, Paper, Skeleton, Typography, useTheme} from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

export interface DailyReportTotalizerCardProps {
    icon: React.ReactNode;
    title: string;
    value: string;
    unit: string;
    subtitle?: string;
    loading?: boolean;
    color?: string;
    showViewIcon?: boolean;
}

export default function DailyReportTotalizerCard({
                                                     icon,
                                                     title,
                                                     value,
                                                     unit,
                                                     subtitle,
                                                     loading = false,
                                                     color = "primary.main",
                                                     showViewIcon = false,
                                                 }: DailyReportTotalizerCardProps) {
    const theme = useTheme();
    return (
        <Paper
            elevation={0}
            sx={{
                position: "relative",
                height: "100%",
                p: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                backgroundColor: theme.palette.mode === 'light' ? '' : '#1E1E1E',
            }}
        >
            <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, }}>
                <Box sx={{display: "flex", alignItems: "center", gap: 1.5, minWidth: 0}}>
                    <Box
                        sx={{
                            flexShrink: 0,
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            backgroundColor: theme.palette.mode === 'dark' ? "color-mix(in srgb, " + color + " 70%, #FFFFFF)" : color,
                            // opacity: theme.palette.mode === 'dark' ? 0.6 : 1,
                        }}
                    >
                        {icon}
                    </Box>
                    <Typography
                        variant="h6"
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            color: "text.primary",
                            fontWeight: 500,
                            fontSize: "1.25rem",
                            lineHeight: 1.6,
                            letterSpacing: "0.15px",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
                {showViewIcon && (
                    <InfoOutlined sx={{flexShrink: 0, color: theme.palette.mode === 'dark' ? "color-mix(in srgb, " + color + " 70%, #FFFFFF)" : color,}} fontSize="small"/>
                )}
            </Box>

            <Box sx={{display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 1, flexWrap: "wrap"}}>
                {loading ? (
                    <Skeleton variant="text" width={130} height={32}/>
                ) : (
                    <Typography variant="h6" sx={{fontWeight: 500, color: theme.palette.mode === 'dark' ? "color-mix(in srgb, " + color + " 70%, #FFFFFF)" : color,}}>
                        {`${value} ${unit}`}
                    </Typography>
                )}
                {subtitle && (
                    <Typography variant="caption" sx={{color: "text.secondary"}}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Paper>
    );
}
